<template>
  <!-- 添加团队人员信息 -->
  <div>
    <div class="myupload mt18">
      <div class="myupload_l">
        <el-button type="primary" icon="el-icon-plus" @click="addProDialog">添加核心人员信息（必选）</el-button>
      </div>
    </div>
    <el-table :data="list" border style="width: 100%;margin-top:20px;" class="mt18">
      <el-table-column prop="team_member_name" label="姓名"></el-table-column>
      <el-table-column prop="team_member_post" label="职位"></el-table-column>
      <el-table-column prop="team_member_major" label="专业"></el-table-column>
      <el-table-column prop="team_member_education_name" label="学历"></el-table-column>
      <el-table-column prop="team_member_id_card" label="身份证号"></el-table-column>
      <el-table-column prop="team_member_phone" label="手机号"></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <div class="blue_btn" @click="editDialog(scope)">编辑</div>
          <div class="blue_btn" @click="removeDialog(scope)">删除</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加资质 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :title="`${title}核心人员信息`"
      width="500px"
      destroy-on-close
    >
      <el-form class="add_team_from" :model="ruleForm" ref="ruleForm" label-width="120px" label-position="right">
        <el-form-item
          label="姓名："
          prop="team_member_name"
          :rules="[{required: true, message: '请填写姓名', trigger: 'blur,change'}]"
        >
          <el-input
            class="input-width"
            v-model="ruleForm.team_member_name"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="最高学历："
          prop="team_member_education"
          :rules="[{ required: true, message: '请选择最高学历', trigger: 'blur' }]"
        >
          <el-select v-model="ruleForm.team_member_education" placeholder="请选择" class="input-width">
            <el-option
              v-for="item in EducationType"
              :key="item.id"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="team_member_major"
          label="专业："
          :rules="[{ required: true, message: '请填写专业', trigger: 'blur' }]"
        >
          <el-input
            class="input-width"
            v-model="ruleForm.team_member_major"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="team_member_id_card"
          label="身份证件号码："
          :rules="[{ required: true, message: '请填写身份证件号码', trigger: 'blur' }]"
        >
          <el-input
            class="input-width"
            v-model="ruleForm.team_member_id_card"
            placeholder="请输入身份证件号码"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="team_member_post"
          label="职位："
        >
          <el-input
            class="input-width"
            v-model="ruleForm.team_member_post"
            placeholder="请输入职位或填“无”"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="team_member_phone"
          label="手机号码："
          :rules="[{ required: true, message: '请填写手机号码', trigger: 'blur' }]"
        >
          <el-input
            class="input-width"
            v-model="ruleForm.team_member_phone"
            placeholder="请输入手机号码"
            maxlength="11"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm','save')">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      title: "添加",
      ruleForm: {}, //弹窗表单
      dialogVisible: false,
      index: 0, //编辑选中的下标
      apiParams5: {
        params: {
          catalog: "CatalogUserHead",
          is_public_read: true
        },
        imgPath: "headPath", //图片展示字段
        fileId: "head" //文件id字段
      },
      EducationType: [
        {
          code: "EducationTypeJuniorCollege",
          name: "专科",
          typeName: "学历",
          typeId: "49a6722a99cd75bf5dbd82cb40ed508b",
          id: "0defb4ba75111121a6b8e600e619955c",
          typeCode: "EducationType"
        },
        {
          code: "EducationTypeCollege",
          name: "本科",
          typeName: "学历",
          typeId: "49a6722a99cd75bf5dbd82cb40ed508b",
          id: "996548947f2e64626665deb7e6269a9c",
          typeCode: "EducationType"
        },
        {
          code: "EducationTypeMaster",
          name: "硕士研究生",
          typeName: "学历",
          typeId: "49a6722a99cd75bf5dbd82cb40ed508b",
          id: "25babfa72dafac2fded38775f338d74e",
          typeCode: "EducationType"
        },
        {
          code: "EducationTypeDoctoral",
          name: "博士研究生",
          typeName: "学历",
          typeId: "49a6722a99cd75bf5dbd82cb40ed508b",
          id: "b6b9ac6bb3b52fcc39ca4a32b8add14a",
          typeCode: "EducationType"
        },
        {
          code: "EducationTypeOther",
          name: "其他",
          typeName: "学历",
          typeId: "49a6722a99cd75bf5dbd82cb40ed508b",
          id: "45b19cd861bf6a4191fe2c7b83a7d178",
          typeCode: "EducationType"
        }
      ], //学历
      list: []
    };
  },
  created() {
    // this.getDict("EducationType", "EducationType"); //学历
  },
  mounted() {
    this.getExtends();
  },
  methods: {
    submitForm(formName, type) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
          if (!myreg.test(this.ruleForm.team_member_phone)) {
            this.$message.warning("手机号格式不正确");
            return
          }
          if (this.title === "添加") {
            this.add(type);
          } else {
            this.updateExtend();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 查询列表
    getExtends() {
      let params = Object.assign(
        {},
        {
          code: this.params.code,
          type: "StarryExtendTypeTeamMember",
          pageSize: 10
        }
      );
      this.api.getExtends(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.list = res.obj.list;
        this.ruleForm = {};
      });
    },
    /** 操作*/
    makesome(type) {
      let obj = {
        type
      };
      this.$emit("handler", obj);
    },
    addProDialog() {
      this.dialogVisible = true;
      this.title = "添加";
    },
    add(type) {
      let params = Object.assign({}, this.ruleForm, {
        code: this.params.code,
        type: "StarryExtendTypeTeamMember"
      });
      this.api.createExtend(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.dialogVisible = false;
        this.getExtends();
      });
    },

    /** 编辑资质*/
    editDialog(scope) {
      this.index = scope.$index;
      this.dialogVisible = true;
      this.ruleForm = Object.assign({}, scope.row);
      this.title = "编辑";
      this.$nextTick(() => {
        this.$refs["ruleForm"].validate(valid => {});
      });
    },
    /** 移除弹窗*/

    removeDialog(scope) {
      this.$confirm("确定移除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.remove(scope.row);
        })
        .catch(() => {});
    },
    /** 编辑*/
    updateExtend() {
      let params = Object.assign({}, this.ruleForm, {
        code: this.params.code,
        type: "StarryExtendTypeTeamMember"
      });
      this.api.updateExtend(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.getExtends();
        this.dialogVisible = false;
        this.$message({
          message: `更新成功`,
          type: "success"
        });
      });
    },
    /** 移除*/
    remove(row) {
      let params = {
        ids: row.id
      };
      this.api.deleteExtend(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.getExtends();
        this.$message({
          message: `更新成功`,
          type: "success"
        });
      });
    },
    //获取字典
    getDict(typeCode, key) {
      this.api
        .getDictionaries({
          pageSize: 999,
          typeCode: typeCode
        })
        .then(res => {
          if (res.error["err_code"] !== 0) return;
          this[key] = res.obj.list;
        });
    }
  }
};
</script>

<style lang="scss">
.input689 {
  width: 689px;
}
.input310 {
  width: 310px;
}
.blue_btn {
  color: $font-blue;
  cursor: pointer;
}
.add_team_from.el-form--label-right{
  .el-form-item__label{
       float: left !important;
       text-align: right;
    }
}
.add_team_from.el-form--label-left{
  .el-form-item__label{
       float: left !important;
       text-align: left;
    }
}

</style>
